/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_BadgeInputs */



/**
* | output |
* | --- |
* | "*NEW*" |
*
* @param {New_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_badge = /** @type {((inputs?: New_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("*NOUVEAU*")
	if (locale === "de") return /** @type {LocalizedString} */ ("*NEU*")
	if (locale === "it") return /** @type {LocalizedString} */ ("*NUOVO*")
	if (locale === "ru") return /** @type {LocalizedString} */ ("*НОВЫЙ*")
	if (locale === "es") return /** @type {LocalizedString} */ ("*NUEVO*")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("*新的*")
	if (locale === "ja") return /** @type {LocalizedString} */ ("*新しい*")
	if (locale === "hi") return /** @type {LocalizedString} */ ("*नया*")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("*NOVO*")
	return /** @type {LocalizedString} */ ("*NEW*")
});